<template>
  <div class="page-content wish_bets_pages">
    <!-- CheckBet PSWS WishBet App -->
    <div v-if="wishBetAuthorizationToken">
      <h1 v-if="!showPageTitleInHeader || (showPageTitleInHeader && tabletAndAbove)">{{ $t('PageTitle.placedbets' )}}</h1>
      <v-btn class="scan_bet_btn" @click="openBarcodeScanner()">
        <span class="barcode_icon"></span>
        <span>{{ $t('WishBet.ScanBarcode' )}}</span>
      </v-btn>
    </div>
    <!-- CheckBet PSWS -->
    <div v-if="isLoggedIn">
      <div class="check_ticket_psws">
        <h3>{{ $t('WishBet.ToCkeckTicketStatus' )}}</h3>
        <p>{{ $t('WishBet.EnterBarcode' )}}</p>
        <div class="input_holder">
          <input type="text" v-model.trim="barcodeVal" inputmode="numeric" autocomplete="off" :class="{'input_error': barcodeInputError}"  @focusout="!barcodeVal ? barcodeInputError = true : barcodeInputError = false"/>
          <span class="clear-btn" >
            <button v-show="barcodeVal" @click="clearInput()"><v-icon>close</v-icon></button>
          </span>
        </div>
        <v-btn class="scan_bet_btn" @click="checkTicketStatus()">
          <span>{{ $t('WishBet.CheckBarcode' )}}</span>
        </v-btn>
        <template v-if="isMobileApp">
          <div class="separator"><span>{{ $t('WishBet.OR' )}}</span></div>
          <p>{{ $t('WishBet.ScanTicketBarcode' )}}</p>
          <v-btn class="scan_bet_btn" @click="openBarcodeScanner()">
            <span class="barcode_icon"></span>
            <span>{{ $t('WishBet.ScanBarcode' )}}</span>
          </v-btn>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
  import store from '@/store'
  import config from '@/config'
  import Screen from '@/components/mixins/Screen'
  import mobileBridge from '@/library/mobileBridge'

  export default {
    name: 'PlacedBetsPage',

    data () {
      return {
        barcodeInput: null,
        barcodeInputError: false
      }
    },

    mixins: [
      Screen
    ],

    components: {
    },

    computed: {
      showPageTitleInHeader () {
        return window.ctsautoconf.PAGE_TITLE_IN_HEADER_ON_MOBILE || false
      },
      wishBetAuthorizationToken () {
        return store.getters['wishBets/wishBetAuthorizationToken']
      },
      isLoggedIn () {
        return store.getters['isLoggedIn']
      },
      isMobileApp () {
        return config && config.app && config.app.autoconf && config.app.autoconf.MOBILE_LS
      },
      barcodeVal: {
        get () {
          return this.barcodeInput
        },
        set (value) {
          this.barcodeInput = value
        }
      }
    },
    methods: {
      openBarcodeScanner () {
        console.log('open barcode scanner')
        mobileBridge.bridgeSendRequest('openBarcodeScaner')
      },
      checkTicketStatus () {
        if (this.barcodeVal) {
          store.dispatch('wishBets/checkTicket', this.barcodeVal)
        } else {
          this.barcodeInputError = true
        }
      },
      clearInput () {
        this.barcodeVal = null
        this.barcodeInputError = false
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
.wish_bets_pages
  height 100vh
>>>.theme--light.v-btn:not(.v-btn--icon):not(.v-btn--flat)
  &.scan_bet_btn
    width 200px
    display flex
    margin 100px auto 0 auto
    color #fff
    background #003764
    background-color #003764
    height auto
    padding 5px
    .v-btn__content
      text-align center
      flex-direction: column

.barcode_icon
  background-image var(--checkbet-barcode-icon)
  width: 35px !important
  height: 30px !important
  margin 5px 0

.check_ticket_psws
  text-align center
  .separator
    padding 30px 0px 10px 0px
    display: flex
    align-items: center
    justify-content: center
    font-family: 'Roboto Condensed Bold'
    font-size 20px
    &:before
      content ''
      width 150px
      height 1px
      margin-right 30px
      background var(--account-pages-text-color)
    &:after
      content ''
      width 150px
      height 1px
      margin-left 30px
      background var(--account-pages-text-color)
  h3 
    font-size 20px
    margin-bottom 50px
    color var(--account-pages-text-color) !important
  p 
    font-family: 'Roboto Condensed'
    font-size 16px
    color var(--account-pages-text-color) !important
  >>>.scan_bet_btn
    height 45px !important
    min-width 250px
    margin 20px auto 0 auto !important
    .v-btn__content
      flex-direction: row !important
      .barcode_icon
        margin-right 10px
        width: 27px !important
        height: 23px !important

  input 
    background var(--checkbet-input-bgr)
    color var(--checkbet-input-color)
    border var(--checkbet-input-border)
    border-radius 5px
    height 40px
    width 280px
    padding 0 5px
    &.input_error
      border var(--form-error-border)
  .input_holder
    display block
    margin auto
    position relative
    width 280px
    height 40px
  .clear-btn
    position absolute
    right 10px
    top 12px
    button
      background  #f2f2f2
      border 1px solid #939eae
      width 15px
      height 15px
      display: flex
      align-items: center
      justify-content: center
      .v-icon
        font-size 14px
</style>



// WEBPACK FOOTER //
// src/components/pages/WishBet/PlacedBetsPage.vue